import { useEffect, useState } from 'react';

const HUBSPOT_SCRIPT_ID = 'hubspot-forms-embed-script';
const HUBSPOT_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/v2.js';

const useHubspotScript = (): boolean => {
  const [isReady, setIsReady] = useState(() => {
    if (typeof window === 'undefined') return false;

    return Boolean(window.hbspt);
  });

  useEffect(() => {
    if (isReady) return;

    const getOrCreateScript = () => {
      const existingScript = document.getElementById(
        HUBSPOT_SCRIPT_ID,
      ) as HTMLScriptElement | null;

      if (existingScript) return existingScript;

      const script = document.createElement('script');

      script.id = HUBSPOT_SCRIPT_ID;
      script.src = HUBSPOT_SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);

      return script;
    };

    if (window.hbspt) {
      setIsReady(true);

      return;
    }

    const script = getOrCreateScript();

    const handleScriptLoad = () => {
      setIsReady(Boolean(window.hbspt));
    };

    script.addEventListener('load', handleScriptLoad);

    return () => {
      script.removeEventListener('load', handleScriptLoad);
    };
  }, [isReady]);

  return isReady;
};

export default useHubspotScript;
